import { render } from "./openList.vue?vue&type=template&id=2a40c85a&scoped=true&ts=true"
import script from "./openList.vue?vue&type=script&lang=ts"
export * from "./openList.vue?vue&type=script&lang=ts"

import "./openList.vue?vue&type=style&index=0&id=2a40c85a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a40c85a"]])

export default __exports__